import React from 'react'
import classNames from 'classnames'

// A checkbox ideally to be used outside of forms
// when onchange and custom behavior is more important than submit
const StandaloneCheckBox = ({
  uid,
  iconSize = '20px',
  index = 0,
  label = '',
  ...props
}) => {
  const style = {
    backgroundSize: iconSize,
    width: iconSize,
    height: iconSize,
  }

  const componentName = `checkbox-${uid}[${index}]`
  return (
    <div key={`${componentName}-container`}>
      <input
        type="checkbox"
        name={componentName}
        id={componentName}
        {...props}
        className={classNames('form__checkbox', {
          'form__checkbox--disabled': false,
        })}
      />
      <label
        style={style}
        className={classNames({
          'form__control--disabled-text': false,
        })}
        htmlFor={componentName}
      >
        {label}
      </label>
    </div>
  )
}

export default StandaloneCheckBox
